export {
  fmtDate as formatDate,
  fmtDateTime,
  fmtDateAuto,
  fmtDateAgo,
  fmtDateAgo as formatDateAgo,
  fmtDuration as formatDuration
} from './format/date';

import { DateTime } from 'luxon';

const INVALID = '—';

/** ISO string → "YYYY-MM-DD HH:MM:SS" */
export const formatToIsoDateTime = (dateString: string): string => {
  const date = DateTime.fromISO(dateString);
  return date.isValid
    ? (date.toISO()?.split('T').join(' ').split('.')[0] ?? INVALID)
    : INVALID;
};

/** ISO string → "12 Jul 2026" (delegates to fmtDate) */
export const formatDateYearMonthDay = (dateString: string): string => {
  const date = DateTime.fromISO(dateString);
  return date.isValid ? date.toFormat('d MMM yyyy') : INVALID;
};

/** ISO/timestamp → locale string, falls back to em-dash */
export const safeToLocaleString = (dateString: string): string => {
  const date = new Date(dateString);
  return isNaN(date.getTime()) ? INVALID : date.toLocaleString();
};

/** ISO/timestamp → locale time string, falls back to em-dash */
export const safeToLocaleTimeString = (dateString: string | number): string => {
  const date = new Date(dateString);
  return isNaN(date.getTime()) ? INVALID : date.toLocaleTimeString();
};
